// Main entry point
export {detectCliInstallation} from './detectCliInstallation.js'
